import {
  SET_USER_LOGADO,
  SET_ADRESS_USER,
  SET_ADRESS_TO_DELIVERY,
  SET_DATA_END_ORDER,
  SET_ITENS,
  SET_STORES
} from "./actions"



export const setUserLogado = value => ({
  type: SET_USER_LOGADO,
  payload: value
})


export const setAdressUser = value => ({
  type: SET_ADRESS_USER,
  payload: value
})


export const setAdressToDelivery = value => ({
  type: SET_ADRESS_TO_DELIVERY,
  payload: value
});



export const setDataEndOrder = value => ({
  type: SET_DATA_END_ORDER,
  payload: value
});


export const setItens = value => ({
  type: SET_ITENS,
  payload: value
});



export const setStores = value => ({
  type: SET_STORES,
  payload: value
});